/**
 * Holder for the active ConfigService so it can be replaced (e.g. in tests or different runtimes).
 * Default implementation reads from Vite env; setConfigService() allows swapping.
 */

import type { ConfigService } from "./config.types";
import { EnvConfigService } from "./env-config.service";

let current: ConfigService = new EnvConfigService();

/**
 * Returns the currently active config service.
 */
export function getConfigService(): ConfigService {
	return current;
}

/**
 * Replaces the config service. Use for tests or runtime-specific implementations.
 */
export function setConfigService(service: ConfigService): void {
	current = service;
}

/**
 * Convenience: returns the current config from the active service.
 */
export function getConfig(): ReturnType<ConfigService["getConfig"]> {
	return getConfigService().getConfig();
}
